import { render, staticRenderFns } from "./tracker-organizations-by-region-labels.vue?vue&type=template&id=4487e948&scoped=true&"
import script from "./tracker-organizations-by-region-labels.vue?vue&type=script&lang=js&"
export * from "./tracker-organizations-by-region-labels.vue?vue&type=script&lang=js&"
import style0 from "./tracker-organizations-by-region-labels.vue?vue&type=style&index=0&id=4487e948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487e948",
  null
  
)

export default component.exports